import styled from "styled-components";

import Button from "../Button";
import { colors, fonts } from "../../../styles/variables";

export const FirstText = styled.label`
  font-family: ${fonts.fontBauMedium};
  font-size: 12px;
`;

export const MiddleDivider = styled.label`
  font-family: ${fonts.fontBauMedium};
  font-size: 17px;
  line-height: 17px;
  margin: 0 10px;
`;

export const SecondText = styled.label`
  font-family: ${fonts.fontInterstateBlackCompressed};
  font-size: 25px;
  line-height: 25px;
`;

export const StyledButton = styled(Button)<{
  isGrayed?: boolean;
}>`
  font-weight: normal;
  padding: 18px 16px;
  margin-right: 16px;
  margin-bottom: 16px;

  * {
    cursor: inherit;
  }

  ${(props) =>
    props.isGrayed &&
    `
    &, &:hover, &:focus {
      border: 1px solid ${colors.gray};
      background-color: ${colors.gray};
      color: ${colors.white};
    }
    `};
`;
